import { queryOptions, useQuery } from '@tanstack/react-query';

import { customersApi } from '../api/customers-api';

import { customerKeys } from './customer-keys';

export function customerQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: customerKeys.detail(storeId, id),
    queryFn: () => customersApi.get(storeId, id),
  });
}

export function useCustomer(storeId: string, id: string) {
  return useQuery(customerQueryOptions(storeId, id));
}
